import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import styled from "styled-components";

export interface StyledTableProps {
    nthChildIndex?: number;
    nthChildWidth?: string;
}

const StyledTable = styled.table<StyledTableProps>`
    width: 100%;
    border-collapse: collapse;
    overflow-x: auto;
    margin-top: 32px;

    thead {
        background-color: ${themeBackgrounds.offWhite};

        th {
            font-size: ${fontSizes.xSmall};
            line-height: ${lineHeights.default};
            color: ${themeBackgrounds.darkGray};
        }
        td {
            color: ${themeBackgrounds.darkGray};
        }
    }

    tbody,
    tfoot {
        td {
            font-size: ${fontSizes.small};
            line-height: ${lineHeights.default};
        }
    }

    th,
    td {
        padding: 4px;
        border: 1px solid ${themeBackgrounds.lightGray};
        text-align: left;
        white-space: nowrap;
    }

    ${props =>
        props.nthChildIndex && props.nthChildWidth
            ? `
                th:nth-child(${props.nthChildIndex}),
                td:nth-child(${props.nthChildIndex}) {
                    min-width: ${props.nthChildWidth};
                }
            `
            : ""}
`;

export default StyledTable;
